import MultiAddCerts from "../components/MultiAddCerts";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";

function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateCerts: (certs: string[]) => {
      dispatch(actions.updateUi("addCertList", certs));
    },
    submitCerts: (certs: string[]) => {
      dispatch(
        actions.updateFilter(
          "multiCert",
          certs.map(cert => cert.trim()),
        ),
      );
      dispatch(actions.updateUi("searchPush", true));
      dispatch(actions.searchPush());
    },
  };
}
export default connect(null, mapDispatchToProps)(MultiAddCerts);
